import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IFile } from 'types/file'

export const fileApi = createApi({
  reducerPath: 'files',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getFile: builder.query<IFile, IdParams>({
      query: ({ id }) => `/files/${id}`,
    }),

    downloadFile: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/files/${id}/download`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        responseHandler: async (response) => await response.blob(),
      }),
    }),

    deleteFile: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/files/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const { useDownloadFileMutation, useGetFileQuery, useDeleteFileMutation } =
  fileApi
